import React from 'react'
import { get } from 'lodash'
import popup from '../../popup'
import './style.css'
import userStore from '~/redux/user/store'
import {login,getCardInfo,refresh } from '~/redux/user/actions'
import { addUserProfile, trackEvent } from '~/tools/analytics/cleverTap'


class LoginEmailPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.metaDataMap=this.props.args.metaDataMap;
  }

  getVal(key){
    return get(this.metaDataMap, key)
  }

  loginSubmit = ()=>{
    var creds = {
        email: this.emailInput.value,
        password: this.passwordInput.value
    }

    if(this.props.onInitiate){ this.props.onInitiate('login') }
      userStore
      .dispatch(login(creds))
      .then( _ => {
        var userInfo = userStore.getState().user || {}
        userInfo && addUserProfile("Site", {
          Name: userInfo.name,
          Email: userInfo.email,
          Identity: userInfo.userId,
          "User Status": userInfo.isSubscribed
            ? "Subscribed"
            : "Registered and Never Subscribed"
        });

        this.setState({ buttonProgress: false })
        popup.hide()     
        
        trackEvent('Login', {platform: 'Web', registrationType: 'Native'})
        userStore
          .dispatch(getCardInfo(userInfo))
          .then(res => {
            if(!userInfo.phoneNumber)
              popup.updateNumber(this.metaDataMap);
            if((userInfo.phoneNumber && (userInfo.phoneNumber=="" || userInfo.phoneNumber==" " || userInfo.phoneNumber=="NA")))
              popup.updateNumber(this.metaDataMap);
        });
       
      })
      .then(res => {
        userStore
        .dispatch(refresh())
      })
      .catch( error => {
        var errorCode = ""
        this.setState({ buttonProgress: false })
        if(error.response && error.response.data) {
          errorCode = error.response.data.code
        }
        var message = this.getVal(errorCode) || this.getVal('defaultError') ;
        this.alert(message)
        if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
      })
  }

  alert(txt) {
    this.setState({ error: txt })
  }

  render() {
    return (
      <div className="auth-view centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <div className="intro"> {this.getVal('loginEmailPassword') || "Login with Email and Password"}</div>
        <form
          className="login-view"
          onSubmit={ evt => {
            evt.preventDefault()
            this.loginSubmit();
          }}>
            <div className="input-box">
                <input  
                    type="email" 
                    placeholder="Enter Your Email"
                    ref={ i => { this.emailInput = i} }  
                    autoFocus 
                    required               
                />
            </div>

            <div className="input-box">
                <input
                    placeholder="Enter Your Password"
                    ref={ i => { this.passwordInput = i} }
                    type="password"
                    required/>
            </div>

            <div className={ `error-box collapsible ${ this.state.error ? '' : 'collapsed' }` }>
              { this.state.error || '' }
            </div>

            <input
              type="submit"
              value={this.getVal('loginCta')}
              className="login-button button fat cta">
            </input>

            <div
                className="forgot-password-button fat"
                onClick={ _ => { popup.forgotPassword(this.props.hardwall, this.metaDataMap) } }>
                  {this.getVal('forgotPasswordCtaText')}
              </div>
        </form>
      </div>
    )
  }
}

export default LoginEmailPassword;